<template>
  <div
    v-if="Alarm"
    class="bg-orange-400 uppercase relative w-full text-sm text-center"
  >
    <div class="animate-pulse absolute w-full h-full bg-red-700"></div>
    <div class="relative bg-transparent z-1 py-1">{{ $e("Alarme actif")}}</div>
  </div>
  <div
    v-if="EmerStop"
    class="bg-orange-400 uppercase relative w-full text-sm text-center"
  >
    <div class="animate-pulse absolute w-full h-full bg-red-700"></div>
    <div class="relative bg-transparent z-1 py-1">{{ $e("Arrêt d'urgence actif")}}</div>
  </div>
</template>

<script>
export default {
  props: {
    config: Object,
  },
  computed: {
    Alarm() {
      return this.config?.dock?.status?.alarm_state != undefined
        ? this.config?.dock?.status?.alarm_state == 1
        : false;
    },

    EmerStop() {
      return this.config?.dock?.status?.emergency_stop_state != undefined
        ? this.config?.dock?.status?.emergency_stop_state == 1
        : false;
    },
  },
};
</script>
